import React, { useEffect } from "react";
import "../../assets/css/layout.css";
import "../../assets/css/main.css";
import "../../assets/css/common.css";
import "../../assets/css/sub.css";
import "../../assets/css/slick.css";
import allBtn from "../../assets/img/common/all_btn1.png";
import allCross from "../../assets/img/common/all_cross1.png";
import home from "../../../src/assets/img/icon_home.png";
import logoKakaoMap from "../../../src/assets/img/logo_kakaomap.png";
import { routes } from "../../lib/routes";
import { Link } from "react-router-dom";
import SideBar from "../../components/common/SideBar";
const { kakao } = window;
export default function Directions() {
  useEffect(() => {
    const container = document.getElementById("headOffice");
    const options = {
      center: new kakao.maps.LatLng(37.5709781, 126.9890381),
      level: 3,
    };
    const map = new kakao.maps.Map(container, options);
    // 정상적으로 검색이 완료됐으면

    let markerPosition = new kakao.maps.LatLng(
      37.57102894864521,
      126.99119327869761
    );
    let marker = new kakao.maps.Marker({
      position: markerPosition,
    });
    marker.setMap(map);
  }, []);

  useEffect(() => {
    const container = document.getElementById("store");
    const options = {
      center: new kakao.maps.LatLng(37.57014377275733, 126.99192066460148),
      level: 3,
    };
    const map = new kakao.maps.Map(container, options);
    let markerPosition = new kakao.maps.LatLng(
      37.57014377275733,
      126.99192066460148
    );
    let marker = new kakao.maps.Marker({
      position: markerPosition,
    });

    marker.setMap(map);
    return map;
  }, []);

  const dropDownFirstTab = () => {
    let clickFirstTab = document.getElementById("myDropdown1");
    if (clickFirstTab.className === "dropdown-content") {
      clickFirstTab.className = "dropdown-content show";
    } else {
      clickFirstTab.className = "dropdown-content";
    }
  };
  const dropDownSecondTab = () => {
    let clickSecondTab = document.getElementById("myDropdown2");
    if (clickSecondTab.className === "dropdown-content") {
      clickSecondTab.className = "dropdown-content show";
    } else {
      clickSecondTab.className = "dropdown-content";
    }
  };
  return (
    <>
      <div
        className="all_box1"
        style={{
          position: "absolute",
          left: "50%",
          marginLeft: "500px",
          top: "75px",
        }}
      >
        <Link to="#layer" className="btn-layer">
          <img src={allBtn} alt="전체메뉴" />
        </Link>
      </div>
      {/* <!-- Start : layer-popup content --> */}
      <div id="layer" className="layer-wrap">
        <div className="pop-layer">
          <div className="pop-container">
            <div className="pop-conts">
              {/* <!-- content --> */}
              <div className="allmenu1">
                <h2 className="alltitl">All Menu</h2>
                <ul className="menulist">
                  <li>
                    <dl>
                      <dt>귀금속시세</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to={routes.domesticPriceInquiry}>
                              국내시세
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.internationalPriceInquiry}>
                              국제시세
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.diamondPriceInquiry}>
                              다이아몬드 시세
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.securitiesPriceInquiry}>
                              유가증권
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>상품소개</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to="/product/productall.html">원자재</Link>
                          </li>
                          <li>
                            <Link to="/product/securitiesgd.html">
                              유가증권
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>기념품 제작</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to="#" href="/souvenir/inquiry.html">
                              제작문의 조회
                            </Link>
                          </li>
                          <li>
                            <Link to="#" href="/souvenir/inquiryRegister.html">
                              제작문의 등록
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>뉴스센터</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to={"/newscenter/marketNoticeList.html"}>
                              뉴스
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>공지사항</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to="#" href="/notice/announcementList.html">
                              공지사항
                            </Link>
                          </li>
                        </ul>
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt>회사소개</dt>
                      <dd>
                        <ul>
                          <li>
                            <Link to={routes.companyIntroduction}>
                              회사소개
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.companyGreeting}>CEO인사말</Link>
                          </li>
                          <li>
                            <Link to={routes.companyHistory}>회사연혁</Link>
                          </li>
                          <li>
                            <Link to={routes.companyBusinessIntroduction}>
                              사업소개
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.companyBrandIntroduction}>
                              브랜드소개
                            </Link>
                          </li>
                          <li>
                            <Link to={routes.companyDirections}>오시는 길</Link>
                          </li>
                          {/* <li>
                            <Link to={routes.companyFranchiseInvitation}>
                              가맹점 모집
                            </Link>
                          </li> */}
                        </ul>
                      </dd>
                    </dl>
                  </li>
                </ul>
              </div>
              <Link to="#" href="#" className="btn-layerClose">
                <img src={allCross} alt="닫기" />
              </Link>
              {/* <!--// content--> */}
            </div>
          </div>
          {/* <!-- End : layer-popup content --> */}
        </div>
      </div>
      {/* <!--=============================================================**헤더 영역 끝-->
		<!-- wrap --> */}
      <div id="wrap">
        {/* <!-- 비쥬얼 박스 시작 --> */}
        <div className="svisual_box">
          <div className="sub_visual5_bg">
            <div className="subvisual_wrap">
              <dl className="sub_vtitl1">
                <dt>회사소개</dt>
                <dd>Company Introduction</dd>
              </dl>
              <div className="location_wrap">
                <div className="location_box">
                  <dl>
                    <dt className="home">
                      <Link to="/">
                        <img src={home} alt="home" />
                      </Link>
                    </dt>
                    <dd className="dep_menu1">
                      <button onClick={dropDownFirstTab} className="dropbtn">
                        회사소개
                      </button>
                      <div id="myDropdown1" className="dropdown-content">
                        <Link to={routes.domesticPriceInquiry}>시세조회</Link>
                        {/* <Link
                          style={{display: "none"}}
                        >
                          상품안내
                        </Link>
                        <Link style={{display: "none"}}>
                          기념품제작
                        </Link>
                        <Link
                        //   to="/newscenter/newsNoticeList.html"
                          style={{display: "none"}}
                        >
                          뉴스센터
                        </Link>
                        <Link
                          href="/notice/announcementList.html"
                          style={{display: "none"}}
                        >
                          공지사항
                        </Link> */}
                      </div>
                    </dd>
                    <dd className="dep_menu2">
                      <button onClick={dropDownSecondTab} className="dropbtn">
                        오시는길
                      </button>
                      <div id="myDropdown2" className="dropdown-content">
                        <Link to={routes.companyIntroduction}>회사소개</Link>
                        <Link to={routes.companyGreeting}>CEO 인사말</Link>
                        <Link to={routes.companyHistory}>회사연혁</Link>
                        <Link to={routes.companyBusinessIntroduction}>
                          사업소개
                        </Link>
                        <Link to={routes.companyBrandIntroduction}>
                          브랜드소개
                        </Link>
                        {/* <Link to={routes.companyFranchiseInvitation}>
                          가맹점 모집
                        </Link> */}
                      </div>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sub_container">
          <div className="sub_container_wrap">
            {/* <!-- lnb start --> */}
            <SideBar />
            {/* <!-- lnb end -->
					<!-- contents start --> */}
            <div className="contents">
              <div className="con_titl1">
                <h4>오시는 길</h4>
                <span>Directions</span>
              </div>
              <h6 className="mtitl1">본사 안내</h6>
              <div className="mem_inpt1">
                <div
                  id="map"
                  className="map"
                  style={{ width: "100%", height: "360px" }}
                >
                  {/* <!-- * 카카오맵 - 지도퍼가기 -->
								<!-- 1. 지도 노드 --> */}
                  <div
                    id="daumRoughmapContainer1637817248605"
                    className="root_daum_roughmap root_daum_roughmap_landing"
                  ></div>
                  <div
                    className="map"
                    id="headOffice"
                    style={{ width: "850px", height: "360px" }}
                  ></div>
                </div>
                <div className="wrap_controllers">
                  <Link
                    to="#"
                    className="tit_controllers"
                    href="https://map.kakao.com/"
                    // target="_blank"
                  >
                    <img
                      src={logoKakaoMap}
                      width="72"
                      height="16"
                      alt="카카오맵"
                      style={{
                        display: "block",
                        width: "72px",
                        height: "16px",
                      }}
                    />
                  </Link>
                  <div className="wrap_btn_roadview"></div>
                </div>
                <table summary="오시는 방법" style={{ marginBottom: "50px" }}>
                  <colgroup>
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "*%" }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>오시는 방법</th>
                      <td>지하철 1,3,5호선 종로3가역 2/2-1번 출구 뒷 건물</td>
                    </tr>
                    <tr>
                      <th>주소</th>
                      <td>
                        서울 종로구 돈화문로 5가길 1피카디리플러스 9층 (03139)
                      </td>
                    </tr>
                    <tr>
                      <th>전화번호</th>
                      <td>070-4717-0740</td>
                    </tr>
                    <tr>
                      <th>팩스번호</th>
                      <td>02-741-6314</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h6 className="mtitl2">매장 안내(종로 본점)</h6>
              <div className="mem_inpt2">
                <div
                  id="map"
                  className="map"
                  style={{ width: "100%", height: "360px" }}
                >
                  <div
                    id="daumRoughmapContainer1637817011519"
                    className="root_daum_roughmap root_daum_roughmap_landing"
                  ></div>
                  <div
                    className="map"
                    id="store"
                    style={{ width: "850px", height: "360px" }}
                  ></div>
                </div>
                <div className="wrap_controllers">
                  <Link
                    to="#"
                    className="tit_controllers"
                    href="https://map.kakao.com/"
                    // target="_blank"
                  >
                    <img
                      src={logoKakaoMap}
                      width="72"
                      height="16"
                      alt="카카오맵"
                      style={{
                        display: "block",
                        width: "72px",
                        height: "16px",
                      }}
                    />
                  </Link>
                  <div className="wrap_btn_roadview"></div>
                </div>
                <table summary="오시는 방법" style={{ marginBottom: "50px" }}>
                  <colgroup>
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "*%" }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>오시는 방법</th>
                      <td>지하철 1,3,5호선 종로3가역 14번 출구 앞</td>
                    </tr>
                    <tr>
                      <th>주소</th>
                      <td>서울 종로구 종로 128 화영빌딩 1층(03192)</td>
                    </tr>
                    <tr>
                      <th>전화번호</th>
                      <td>02-744-9999</td>
                    </tr>
                    <tr>
                      <th>팩스번호</th>
                      <td>02-741-6314</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="clear"></div>
            </div>
            {/* <!--contents--> */}
          </div>
        </div>
        {/* <!--**컨테이너 영역 끝--> */}
      </div>
      {/* <!-- ////// wrap --> */}

      <svg
        id="SvgjsSvg1001"
        width="2"
        height="0"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnssvgjs="http://svgjs.com/svgjs"
        style={{
          overflow: "hidden",
          top: "-100%",
          left: "-100%",
          position: "absolute",
          opacity: 0,
        }}
      >
        <defs id="SvgjsDefs1002"></defs>
        <polyline id="SvgjsPolyline1003" points="0,0"></polyline>
        <path id="SvgjsPath1004" d="M0 0 "></path>
      </svg>
    </>
  );
}
